'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
class $c_Lmealorama_components_MealPlanner$RetryDuplicate extends $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_Error {
  constructor(recipe, count) {
    super();
    this.SB = null;
    this.zp = 0;
    this.SB = recipe;
    this.zp = count;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  v() {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
  }
  p() {
    var acc = (-889275714);
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 1926992739);
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.SB));
    acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.zp);
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 2);
  }
  f(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lmealorama_components_MealPlanner$RetryDuplicate)) {
      if ((this.zp === x$0.zp)) {
        var x = this.SB;
        var x$2 = x$0.SB;
        return ((x === null) ? (x$2 === null) : x.f(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  q() {
    return 2;
  }
  r() {
    return "RetryDuplicate";
  }
  g(n) {
    if ((n === 0)) {
      return this.SB;
    }
    if ((n === 1)) {
      return this.zp;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
  }
}
export { $c_Lmealorama_components_MealPlanner$RetryDuplicate as $c_Lmealorama_components_MealPlanner$RetryDuplicate };
function $isArrayOf_Lmealorama_components_MealPlanner$RetryDuplicate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kd)));
}
export { $isArrayOf_Lmealorama_components_MealPlanner$RetryDuplicate as $isArrayOf_Lmealorama_components_MealPlanner$RetryDuplicate };
var $d_Lmealorama_components_MealPlanner$RetryDuplicate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$RetryDuplicate, "mealorama.components.MealPlanner$RetryDuplicate", ({
  kd: 1,
  bK: 1,
  x: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_components_MealPlanner$RetryDuplicate as $d_Lmealorama_components_MealPlanner$RetryDuplicate };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Retry-Duplicate.js.map
